module.exports = __webpack_public_path__ + "static/media/pg_quiz_chemicals.0290742a.jpg";